export enum ServersCode {
  // !Server_Auth
  //Users
  logout = "839d64ee", //POST 10.129.187.254:2999/api/auth/logout
  registration = "982e20d5", //POST 10.129.187.254:2999/api/auth/registration
  registration_tv = "767be1ed", //POST 10.129.187.254:2999/api/auth/registration/tv
  updateUser = "83e1a1fd", //PUT 10.129.187.254:2999/api/auth/user/:id
  postAlive = "bf8f88be", //POST 10.129.187.254:2999/api/auth/alive
  getUserByID = "3b72ec82", //GET 10.129.187.254:2999/api/auth/users/:id
  getUsers = "fe568096", //GET 10.129.187.254:2999/api/auth/users
  getAlive = "1b03a317", //GET 10.129.187.254:2999/api/auth/alive
  forceDeleteUserById = "f00429eb", //DELETE 10.129.187.254:2999/api/auth/users/:id
  messenger = "f4521c13", //POST 10.129.187.254:2999/api/auth/status/:id
  getUnAuthorizedTV = "cbe916b5", //GET 10.129.187.254:2999/api/auth/registration/tv_ticket
  deleteToRecycler = "b6359613", //DELETE 10.129.187.254:2999/api/auth/users/:id
  restoreUserById = "e052bb0d", //PUT 10.129.187.254:2999/api/auth/users/recycler/:id
  //Routes
  getRoutesByRule = "a7be9b42", //GET 10.129.187.254:2999/api/routes
  updateRoutesByRules = "0ec1dac3", //PUT 10.129.187.254:2999/api/routes
  //Rules
  getRules = "313931d8", //GET 10.129.187.254:2999/api/rules
  updateRulesByRule = "cdbb156c", //PUT 192.168.1.214:2999/api/rules

  //Rooms
  getRoomList = "6bff16ab", //GET {{host}}:{{port_auth}}/api/rooms/
  getRoomById = "cd962723", //GET {{host}}:{{port_auth}}/api/rooms/:id
  addNewRoom = "10d950c8", //POST {{host}}:{{port_auth}}/api/rooms/
  updateRoomById = "ca6a5338", //PUT {{host}}:{{port_auth}}/api/rooms/:id
  restoreRoomById = "1ad3f223", //PUT {{host}}:{{port_auth}}/api/rooms/restore/:id
  deleteRoomById = "88a03278", //DELETE {{host}}:{{port_auth}}/api/rooms/:id
  forceDeleteRoomById = "00c1466b", //DELETE {{host}}:{{port_auth}}/api/rooms/force/:id
  //Rooms_type
  getRoomTypes = "44f31ba0", //GET {{host}}:{{port_auth}}/api/rooms/type/
  getRoomTypeById = "6b7866ee", //GET {{host}}:{{port_auth}}/api/rooms/type/:id
  addRoomType = "c87330de", //POST {{host}}:{{port_auth}}/api/rooms/type/
  updateRoomTypeById = "144abf0d", //PUT {{host}}:{{port_auth}}/api/rooms/type/:id
  restoreRoomTypeById = "56fd93cc", //PUT {{host}}:{{port_auth}}/api/rooms/type/restore/:id
  deleteRoomTypeById = "cb936d4a", //DELETE {{host}}:{{port_auth}}/api/rooms/type/:id
  forceDeleteRoomTypeById = "98527643", //DELETE {{host}}:{{port_auth}}/api/rooms/type/force/:id
  //Rooms_Level
  getRoomLevel = "44f31ba0", //GET {{host}}:{{port_auth}}/api/rooms/level/
  getRoomLevelById = "6b7866ee", //GET {{host}}:{{port_auth}}/api/rooms/level/:id
  addRoomLevel = "c87330de", //POST {{host}}:{{port_auth}}/api/rooms/level/
  updateRoomLevelById = "144abf0d", //PUT {{host}}:{{port_auth}}/api/rooms/level/:id
  restoreRoomLevelById = "56fd93cc", //PUT {{host}}:{{port_auth}}/api/rooms/level/restore/:id
  deleteRoomLevelById = "cb936d4a", //DELETE {{host}}:{{port_auth}}/api/rooms/level/:id
  forceDeleteRoomLevelById = "98527643", //DELETE {{host}}:{{port_auth}}/api/rooms/level/force/:id
  //Rooms_status
  gettRoomStatuses = "870175bc", //GET {{host}}:{{port_auth}}/api/rooms/status/
  gettRoomStatusById = "61ba3e8f", //GET {{host}}:{{port_auth}}/api/rooms/status/:id
  addRoomStatus = "d17b739f", //POST {{host}}:{{port_auth}}/api/rooms/status/
  updateRoomStatusById = "76663dad", //PUT {{ {{host}}:{{port_auth}}/api/rooms/status/:id
  restoreRoomStatusById = "75531255", //PUT {{host}}:{{port_auth}}/api/rooms/status/restore/:id
  deleteRoomStatusById = "f06e18af", //DELETE {{host}}:{{port_auth}}/api/rooms/status/:id
  forceDeleteRoomStatusById = "37b00db1", //DEL {{host}}:{{port_auth}}/api/rooms/status/force/:id
  //Guests
  getGuests = "0d53fdd8", //GET {{host}}:{{port_auth}}/api/guests/
  getGuestByID = "1df09eb6", //GET {{host}}:{{port_auth}}/api/guests/:id
  addGuest = "fd0e0743", //POST {{host}}:{{port_auth}}/api/guests/
  updateGuest = "992bb735", //PUT {{ {{host}}:{{port_auth}}/api/guests/:id updateGuest
  restoreGuestById = "c22e70d9", //PUT {{host}}:{{port_auth}}/api/guests/restore/:id
  deleteGuestById = "a94441b1", //DELETE {{host}}:{{port_auth}}/api/guests/:id
  forceDeleteGuestById = "be913de1", //DELETE {{host}}:{{port_auth}}/api/guests/force/:id
  getGuestsExportPhones = "cc0fbc70", // GET {{host}}:2999/api/guests/export/phones

  //Server_Wiki
  //Wiki
  getAllWikiObjects = "c4c71959", //GET http://192.168.1.214:3006/api/wiki/all
  getGPSWikiObjects = "e7d60025", //GET http://192.168.1.214:3006/api/wiki/gps
  getWikiObjectById = "6be24183", //GET http://192.168.1.214:3006/api/wiki/:id
  addNewWikiObject = "11e820d2", //POST http://192.168.1.214:3006/api/wiki
  addManyWikiObject = "ed46b4e6", //POST http://192.168.1.214:3006/api/wiki/clone
  updateWikiObjectById = "c3791d73", //PUT http://192.168.1.214:3006/api/wiki/:id
  forceDeleteWikiObjectById = "3b743abe", //DELETE http://192.168.1.214:3006/api/wiki/force/:id
  recyclerObjectById = "6e7cee4f", //DELETE http://192.168.1.214:3006/api/wiki/:id
  //Recycler
  getAllRecyclerObjects = "3e6e0419", //GET http://192.168.1.214:3006/api/recycler/all
  getRecyclerObjectById = "cd6f0b21", //GET http://192.168.1.214:3006/api/recycler/:id
  wikiRestoreFromRecycler = "6d941194", //PUT http://192.168.1.214:3006/api/recycler/:id
  deleteRecyclerObjectById = "2f19860f", //DELETE http://192.168.1.214:3006/api/recycler/:id

  //Server_Order
  //Bar +
  getBars = "635aae29", //GET 192.168.1.214:3002/api/bars/ +
  addBar = "f95b9d6d", //POST 192.168.1.214:3002/api/bars +
  updateBarById = "8d41d895", //PUT 192.168.1.214:3002/api/bars/:id +
  deleteToRecyclerById = "da6cd5be", // /api/bars/:id +
  restoreBarById = "b48a3d54", // api/bars/restore/:id +
  forceDeleteBarsById = "86c24820", //DELETE 192.168.1.214:3002/api/bars/:id +
  //Category
  getMenuCategory = "dea4d55e", //GET 192.168.1.214:3002/api/category/
  GetCategoryById = "709e5297", //GET 10.129.187.254:3002/api/category/:id
  addCategory = "6ff60c5a", //POST 192.168.1.214:3002/api/category/
  updateCategoryById = "85593250", //PUT 192.168.1.214:3002/api/category/:id
  //Bar Recycler
  forceDeleteCategoryById = "90bf0c3c", //DELETE 192.168.1.214:3002/api/category/force/:id
  restoreCategoryById = "f181004f", //PUT 192.168.1.214:3002/api/category/restore/:id
  deleteCategoryById = "83703a29", //DELETE 192.168.1.214:3002/api/category/:id
  //Menu
  getMenuItemById = "4fa4ef39", //GET 192.168.1.214:3002/api/menu/:id
  getMenu = "6cedf405", //GET 192.168.1.214:3002/api/menu/
  addMenuItem = "8d829295", //POST 192.168.1.214:3002/api/menu
  updateMenuItem = "0bb056b5", //PUT 192.168.1.214:3002/api/menu/:id
  recyclerMenuItemById = "f76b79ac", //DELETE 192.168.1.214:3002/api/menu/:id
  restoreMenuItemById = "3fd7104b", //PUT :3002/api/menu/recycler/:id
  forceDeleteMenuItem = "d530ccae", //DELETE 192.168.1.214:3002/api/menu/force/:id

  //Order
  addNewOrder = "29cbdc39", //POST 192.168.1.214:3002/api/order
  getNewMenuOrders = "8d9475ac", //GET 192.168.1.214:3002/api/order/new
  updateNewOrderByCreater = "8248a1be", //PUT 192.168.1.214:3002/api/order/new/:id
  updateStatusOfNewOrder = "69debe55", //PUT 192.168.1.214:3002/api/order/status/new/:id
  getActiveOrders = "1597eab5", //GET 192.168.1.214:3002/api/order/active
  updateStatusOfActiveOrder = "b9a81b76", //PUT 192.168.1.214:3002/api/order/status/active/:id
  getCanceledOrders = "fa1d9f65", //GET 192.168.1.214:3002/api/order/cancel
  getClosedOrders = "d078ad0e", //GET 192.168.1.214:3002/api/order/closed
  //Reasons
  getReason = "636bdeba", //GET 192.168.1.214:3002/api/reasons
  addReason = "1d3dec7d", //POST 192.168.1.214:3002/api/reasons
  updateReasonsById = "ae261e6a", //PUT 192.168.1.214:3002/api/reasons/:id
  deleteReasonById = "8da516a3", //DELETE 192.168.1.214:3002/api/reasons/:id

  //Server_Channels
  //Channels
  getChannels = "a8425c94", //GET http://192.168.1.214:3003/api/channels/
  getChannelByID = "95cae310", //GET http://192.168.1.214:3003/api/channels/:id
  getChannelsQuery = "f4ad0ecb", //GET http://192.168.1.214:3003/api/channels/all
  addNewChannel = "17b6f0e7", //POST http://192.168.1.214:3003/api/channels/
  forceDeleteChannel = "0c4fbddf", //DELETE http://192.168.1.214:3003/api/channels/force/:id
  moveToRecycler = "bfd73eea", //DELETE http://192.168.1.214:3003/api/channels/:id
  updateChannelByID = "be6473b1", //PUT http://192.168.1.214:3003/api/channels/:id
  addManyNewChannels = "bd08ae9e", //POST http://192.168.1.214:3003/api/channels/clone
  //Channels Recycler
  channelsGetRecycler = "736666d4", //GET http://192.168.1.214:3003/api/channels/deleted/
  channelsRestoreFromRecycler = "ddb3642a", //PUT http://192.168.1.214:3003/api/channels/deleted/:id
  deleteFromRecycler = "3ef03454", //DELETE http://192.168.1.214:3003/api/channels/deleted/:id
  //Content_type
  get_content_type = "83a70a1b", //GET http://10.129.187.234:3003/api/channels/content_type/
  getContent_typeByID = "68fb32f4", //GET http://10.129.187.234:3003/api/channels/content_type/:id
  addContent_type = "73471ae6", //POST http://10.129.187.234:3003/api/channels/content_type/
  updateContent_typeById = "89ad640e", //PUT http://10.129.187.234:3003/api/channels/content_type/:id
  forceDeleteContent_typeById = "318c61b0", //DELETE http://10.129.187.234:3003/api/channels/content_type/force/:id
  deleteContent_typeById = "292060ad", //DELETE http://10.129.187.234:3003/api/channels/content_type/:id
  restoreContent_typeById = "f63d5d23", //PUT http://10.129.187.234:3003/api/channels/content_type/recycler/:id

  //Server_offers
  //Cruises
  forceUpdateCruises = "73b1d30c", //PUT 192.168.1.214:3009/api/cruise
  GetShipsCodesFromCruises = "c8191059", //GET 192.168.1.214:3009/api/cruise/ships/
  GetAllCruises = "f7f82326", //GET 192.168.1.214:3009/api/cruise
  updateImagesCruises = "c9655763", //PUT  10.129.187.234:3009/api/cruise/images
  //Citys
  forceUpdateCitys = "46d41a22", //PUT 192.168.1.214:3009/api/citys
  getAllCitys = "fc1485ed", //GET 192.168.1.214:3009/api/citys
  //Ships
  GetShipsCodesFromShips = "b9ca2064", //GET 192.168.1.214:3009/api/ships/code
  GetAllShips = "be7d3921", //GET 192.168.1.214:3009/api/ships
  getShipById = "7ecc45e3", //GET 192.168.1.214:3009/api/ships/:id
  forceUpdateShips = "fe83ab47", //PUT 192.168.1.214:3009/api/ships
  updateImagesShips = "5b9dfc7c", //PUT 10.129.187.234:3009/api/ships/images

  //Server_RouteInfo
  //Citys
  getAllCitysRouteInfo = "2dfa28b5", //GET 192.168.1.214:3004/api/citys/
  getCityById = "aa04f979", //GET 192.168.1.214:3004/api/citys/:id
  addNewCity = "3afb10d7", //POST 192.168.1.214:3004/api/citys
  forceDeleteCityById = "9dd4d76c", //DELETE 192.168.1.214:3004/api/citys/force/:id
  updateCityById = "7b48fbfb", //UPDATE 192.168.1.214:3004/api/citys/:id
  deleteCityById = "706da2db", //DELETE 192.168.1.214:3004/api/citys/:id (recycler)
  restoreCityById = "7ad50f7b", //PUT 192.168.1.214:3004/api/citys/restore/:id
  updateImagesAutoCitys = "5c8ebf39", //PUT 10.129.187.234:3004/api/citys/auto/images/
  forceUpdateAutoCitys = "82ec3669", //PUT 10.129.187.234:3004/api/citys/auto/update/
  //Routes
  getAllRoutes = "5faadd97", //GET 192.168.1.214:3004/api/routes/
  getRouteByID = "6f8da335", //GET 192.168.1.214:3004/api/routes/:id
  addNewRoute = "3fcee7a0", //POST 192.168.1.214:3004/api/routes
  deleteRouteById = "ec6f63bb", //DELETE 192.168.1.214:3004/api/routes/:id
  updateRouteById = "78544b78", //PUT 192.168.1.214:3004/api/routes/:id
  forceUpdateAutoRoutes = "0abb951c", //PUT 10.129.187.234:3004/api/routes/
  updateConfig = "7fb2ff77", //PUT 10.129.187.234:3004/api/routes/config
  getShips = "3cd3123a", //GET 10.129.187.234:3004/api/routes/ships
  getConfig = "7b9565bd", //GET 10.129.187.234:3004/api/routes/config

  //Server_images
  //Download
  get_dir_pull = "48ebd33c", //GET 10.129.187.254:3010/api/download
  getImageByName = "c00887d7", //GET 10.129.187.254:3010/api/download/:name
  //TemiTable
  getTimetableFiles = "507c99f2", //GET 10.129.187.254:3010/api/timetable
  updateTimetable = "ac09c8f9", //PUT 10.129.187.254:3010/api/timetable
  deleteDirContent = "dcf7185c", //DELETE 10.129.187.254:3010/api/timetable
  //Upload
  uploadImage = "5dd26c1f", //POST 10.129.187.254:3010/api/upload
  //Sections (Инструкции)
  getSections = "507c99f2", //GET {{host}}:3010/api/sections
  updateSections = "ac09c8f9", //POST/PUT {{host}}:3010/api/sections && /api/sections/file/:id
  deleteSections = "dcf7185c", //DELETE {{host}}:3010/api/sections

  //! Server_Cinema
  // Category
  getCinemaCategory = "566f9105", //GET 192.168.1.214:3005/api/categorys/
  getCinemaCategoryByID = "e8df38f0", //GET 192.168.1.214:3005/api/categorys/:id
  addCinemaCategory = "a3003642", //POST 192.168.1.214:3005/api/categorys
  updateCinemaCategoryById = "1afd4ab3", //PUT 192.168.1.214:3005/api/categorys/:id
  // Category Recycler
  deleteCinemaCategoryById = "e8b34bb1", //DELETE 192.168.1.214:3005/api/categorys/:id
  restoreCinemaCategoryById = "322f167e", //PUT 192.168.1.214:3005/api/categorys/restore/:id
  forceDeleteCinemaCategoryById = "37873b2d", //DELETE 192.168.1.214:3005/api/categorys/force/:id
  // Films
  addNewFilmAuto = "d5f93806", //POST 192.168.1.214:3005/api/films/auto
  addNewFilm = "358d9e70", //POST 192.168.1.214:3005/api/films
  getAllFilms = "4482de38", //GET 192.168.1.214:3005/api/films
  updateFilmByID = "0cc2431e", //PUT 192.168.1.214:3005/api/films/:id
  getAPIsData = "36198b4f", //GET 192.168.1.214:3005/api/films/meta "Получение мета данных по API KP",
  getFilmByID = "945cf04b", //GET 192.168.1.214:3005/api/films/:id
  // Movie
  getMovie = "96a300e1", //GET 192.168.1.214:3005/api/movie/:id
  // FIlms Recycler
  deleteFilmToRecycler = "61682ce7", //DELETE 192.168.1.214:3005/api/films/recycler/:id
  forceDeleteFilm = "23546ea6", //DELETE 192.168.1.214:3005/api/films/:id "Принудительное удадение"
  restoreFromRecyclerById = "dfdf63a9", //PUT 192.168.1.214:3005/api/films/recycler/:id

  // Excursions Server
  // Excursions
  getAllExcursions = "690c4e56", //GET 10.129.187.234:3011/api/excursions/
  getExcursionById = "72729908", //GET 10.129.187.234:3011/api/excursions/:id
  addExcursion = "44d14142", // POST 10.129.187.234:3011/api/excursions
  updateExcursionById = "b9605c9c", // PUT 10.129.187.234:3011/api/excursions/:id
  moveExcursionToRecycler = "41cdb451", // DELETE 10.129.187.234:3011/api/excursions/:id (41cdb451)
  restoreExcursionById = "44e50144", // PUT 10.129.187.234:3011/api/excursions/restore/:id
  forceDeleteExcursionById = "1fa1f5ec", // DELETE 10.129.187.234:3011/api/excursions/force/:id
  // Categorys
  getExcursionsCategory = "3dff26bb", // GET 10.129.187.234:3011/api/category/
  getExcursionsCategoryById = "8b6e5f12", // GET 10.129.187.234:3011/api/category/:id
  addNewExcursionsCategory = "8102957f", // POST 10.129.187.234:3011/api/category/
  updateExcursionsCategoryById = "381c7b42", // PUT 10.129.187.234:3011/api/category/:id
  forceDeleteExcursionsCategoryById = "02542401", // DELETE 10.129.187.234:3011/api/category/force/:id
  moveExcursionsCategoryToRecycler = "4f8a0633", // DELETE 10.129.187.234:3011/api/category/:id
  restoreExcursionsCategoryFromRecycler = "b7fcbc9f", // PUT 10.129.187.234:3011/api/category/restore/:id

  //Gallery
  // Formats
  getGalleryFormats = "f59277c2", // GET :3013/api/format/
  getGalleryFormatsByID = "207ed23a", // GET :3013/api/format/:id
  addGalleryFormat = "5ca11fc4", // POST :3013/api/format/
  restoreGalleryFormatsById = "959009dd", // PUT "/api/category/format/:id"
  updateGalleryFormatById = "d4116a01", // PUT :3013/api/format/:id
  deleteGalleryFormatById = "58d6bbf0", // DELETE :3013/api/format/:id
  forceDeleteGalleryFormatById = "3589dbf5", // DELETE "/api/format/force/:id"
  deleteFormatById = "58d6bbf0", //DELETE {{host}}:3013/api/format/:id deleteFormatById
  // main API
  getAllGallery = "3d813d1a", //GET 10.129.187.234:3013/api/gallery/ && /api/categorys/
  getGalleryFTP = "84d0fae1", // GET :3013/api/gallery/dirpull
  addGallery = "179f627b", //POST 10.129.187.234:3013/api/gallery/ && api/categorys
  updateGalleryById = "de77b741", //PUT 10.129.187.234:3013/api/gallery/:id && /api/categorys
  forceDeleteGalleryById = "66a2f1ce", //DELETE 10.129.187.234:3013/api/gallery/force/:id && /api/categorys/force/
  deleteGalleryById = "76295599", //DELETE {{host}}:3013/api/gallery/:id && api/categorys/
  //Orders
  getGalleryForOrder = "e70c7803", //POST 10.129.187.234:3013/api/gallery/order
  uploadImageToGallery = "b1370d66", //POST {{host}}:3013/api/gallery uploadImage

  //!Server_HotelInfo
  //Info
  getAllHotelInfos = "0d0b9a2d", //GET {{host}}:3007/api/info
  getHotelInfoById = "b67e2061", //GET {{host}}:3007/api/info/:id
  addHotelInfo = "9ac8dd10", //POST {{host}}:3007/api/info
  updateHotelInfoById = "982581d2", //PUT {{host}}:3007/api/info/:id
  forceDeleteHotelInfoById = "08215e8c", //DELETE {{host}}:3007/api/info/force/:id
  recyclerInfoObjectById = "5c05b476", //DELETE {{host}}:3007/api/info/:id
  restoreInfoFromRecycler = "b375f3a9", //PUT {{host}}:3007/api/info/restore/:id

  //Staff
  getStaffList = "2d340278", //GET
  getStaffById = "0e289a25", //GET
  addStaff = "102eb8f3", //POST
  updateStaffById = "315af5e8", //PUT
  restoreStaffById = "8bd782ae", //PUT
  recyclerStaffById = "8106dd22", //DELETE recyclerObjectById
  forceDeleteStaffById = "6b267df7", //DELETE

  // !GPS server
  //GPS
  getGps = "7c262ad4", //GET {{host}}:3000/api/gps getgps
  //Flight
  getFlight = "169c4e2a", //GET {{host}}:3000/api/fly getflight
  //Geocoder
  getGeocoder = "3ce271c1", //GET {{host}}:3000/api/geocoder getgeocoder
  //Config
  getGpsConfig = "3f4a3d40", //GET {{host}}:3000/api/fly/config getConfig
  updateGpsConfig = "aa110c40", //PUT {{host}}:3000/api/fly/config updateConfig

  // !Configuration server
  getFiloxeniaConfiguration = "c295ccd9", //GET {{host}}:3014/api/config
  updateFiloxeniaConfiguration = "c7872c7a", //PUT {{host}}:3014/api/config updateConfig
  // Currency
  getAllCurrency = "bff2a8a1", //GET {{host}}:{{port_conf}}/api/сurrency/
  addCurrency = "42303f7b", //POST {{host}}:{{port_conf}}/api/сurrency/
  updateCurrencyById = "504b71ec", //PUT {{host}}:{{port_conf}}/api/сurrency/:id
  deleteCurrencyById = "4b8e26fd", //DELETE {{host}}:{{port_conf}}/api/сurrency/:id
  forceDeleteCurrencyById = "58709d17", //DELETE {{host}}:{{port_conf}}/api/сurrency/force/:id
  restoreCurrencyById = "b37f4394", //PUT {{host}}:{{port_conf}}/api/сurrency/restore/:id

  // !Audio server
  getFSAudio = "046b6169", // GET {{host}}/audio_fs "get_dir_pull"
  addFSAudio = "6bc960b3", // POST {{host}}/audio_fs
  getAudioSongs = "046b6169", // GET {{host}}/api/songs/ "get all songs"
  AddAudioSong = "6bc960b3", // POST {{host}}/api/songs/ "add songs"
  AddAudioCategory = "f04cfff0", // POST {{host}}/api/categorys/
  updateAudioCategory = "81456624", // PUT {{host}}/api/categorys/

  // !Audiobooks server
  getAudiobooks = "046b6169", // GET {{host}}:3015/api/books
  getAudiobookById = "1379ecf3", // GET {{host}}:3015/api/books/:id
  addAudiobook = "6bc960b3", // POST {{host}}:3015/api/books
  updateAudiobook = "78904292", // PUT {{host}}:3015/api/books/:id
  deleteAudiobook = "40f328ac", // DELETE {{host}}:3015/api/books/:id
  restoreAudiobook = "a0892367", // PUT {{host}}:3015/api/books/restore/:id
  forceDeleteAudiobook = "d6c44f0d", // DELETE {{host}}:3015/api/books/force/:id
  deleteAudiobookChapter = "audiobook_delete_chapter", // DELETE {{host}}:3015/api/books/stream/:audiobookId/chapters/:chapterId
  uploadAudiobookPoster = "5dd26c1f", // POST {{host}}:3010/api/upload/new?path=audio/audiobooks/poster

  // !Room Service Request server (:3002, mounted on order service)
  getRoomServiceRequests = "8d9475ac", // GET :3002/api/service/admin/all
  addRoomServiceRequest = "29cbdc39", // POST :3002/api/service/admin
  updateRoomServiceRequest = "8248a1be", // PUT :3002/api/service/admin/:id
  cancelRoomServiceRequest = "29cbdc39", // DELETE :3002/api/service/my/:id
}
